import { AdminAuth } from '@cookspace-shared-contracts/core';

import { baseApi } from '@/api/baseApi';
import { parseWithSchema } from '@/lib/safeParse';

/**
 * RTK Query endpoints для admin-backend /admin-auth/*.
 *
 * На каждый response вызывается parseWithSchema — это страхует фронт
 * от drift'а контракта (правило api-contracts.md).
 */
export const authApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation<AdminAuth.AdminLoginResponse, AdminAuth.AdminLoginRequest>({
            query: (body) => ({
                url: '/admin-auth/login',
                method: 'POST',
                body
            }),
            transformResponse: (raw: unknown): AdminAuth.AdminLoginResponse =>
                parseWithSchema(AdminAuth.AdminLoginResponseSchema, raw)
        }),

        twofaVerify: build.mutation<
            AdminAuth.Admin2faVerifyResponse,
            AdminAuth.Admin2faVerifyRequest
        >({
            query: (body) => ({
                url: '/admin-auth/2fa-verify',
                method: 'POST',
                body
            }),
            transformResponse: (raw: unknown): AdminAuth.Admin2faVerifyResponse =>
                parseWithSchema(AdminAuth.Admin2faVerifyResponseSchema, raw),
            invalidatesTags: ['AdminMe']
        }),

        refresh: build.mutation<AdminAuth.AdminRefreshResponse, void>({
            query: () => ({
                url: '/admin-auth/refresh',
                method: 'POST'
            }),
            transformResponse: (raw: unknown): AdminAuth.AdminRefreshResponse =>
                parseWithSchema(AdminAuth.AdminRefreshResponseSchema, raw)
        }),

        logout: build.mutation<AdminAuth.AdminLogoutResponse, void>({
            query: () => ({
                url: '/admin-auth/logout',
                method: 'POST'
            }),
            transformResponse: (raw: unknown): AdminAuth.AdminLogoutResponse =>
                parseWithSchema(AdminAuth.AdminLogoutResponseSchema, raw),
            invalidatesTags: ['AdminMe']
        }),

        me: build.query<AdminAuth.AdminGetMeResponse, void>({
            query: () => ({
                url: '/admin-auth/me',
                method: 'GET'
            }),
            transformResponse: (raw: unknown): AdminAuth.AdminGetMeResponse =>
                parseWithSchema(AdminAuth.AdminGetMeResponseSchema, raw),
            providesTags: ['AdminMe']
        })
    })
});

export const {
    useLoginMutation,
    useTwofaVerifyMutation,
    useRefreshMutation,
    useLogoutMutation,
    useMeQuery
} = authApi;
